import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const it: DeepPartial<Messages> = {
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> risultati',
  nextQueriesSuggestions: {
    title: 'Quien buscó {query} también buscó...'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['Cosa stai cercando?']
  },
  facets: {
    clearFilters: 'Affina filtri',

    toggle: {
      groups: {
        'all-facets': {
          outside: {
            openHTML: 'Mostra ({selectedFiltersCount}) filtri',
            closeHTML: 'Nascondi filtri'
          }
        }

      }

    }
  },
  nextQueries: {
    titleHTML: ''
  },
  history: {
    disable: 'off',
    enable: 'on'
  },
  results: {
    addToCart: 'Aggiungi al carrello'
  }
};
